module.exports = __webpack_public_path__ + "img/wallet.b545af09.svg";